module.exports = __webpack_public_path__ + "img/logo.f9f1082.png";